import React, { useState } from 'react';
import { Button } from '@capcenter/shared';

import './CopyLink.scss';

const CopyLink = () => {

	const [urlCopied, setUrlCopied] = useState(false);

	function handleCopyUrlClick() {
		navigator.clipboard.writeText(window.location.href);
		setUrlCopied(true);
		setTimeout(function() {setUrlCopied(false);}, 3000);
	}

	return (
		<Button
			resetText
			variant="primary"
			color={ urlCopied ? 'positive' : 'gray'}
			size='sm'
			iconSuffix={urlCopied ? 'far fa-check' : 'far fa-link'}
			label={urlCopied ? 'Copied!' : 'Copy'}
			className="share-link__copy-url-button"
			onClick={handleCopyUrlClick}
		/>
	);
};

export default CopyLink;
